import { Connections } from '../../connections';
import { Stores } from '../index';

export class BaseBackendStore {
  rootStore: Stores;
}
